import { httpClient } from './http-client';
import type { ApiResponse, PaginatedResponse } from './api.types';
import type { Empresa } from '../../modelos/Auth';

export interface CreateEmpresaDTO {
  ruc: string;
  razonSocial: string;
  nombreComercial?: string;
  direccionFiscal?: string;
  codigoDistrito?: string;
  distrito?: string;
  codigoProvincia?: string;
  provincia?: string;
  codigoDepartamento?: string;
  departamento?: string;
  codigoPostal?: string;
  telefonos?: string[];
  correosElectronicos?: string[];
  sitioWeb?: string;
  textoPiePagina?: string;
  actividadEconomica?: string;
  regimenTributario?: string;
  monedaBase?: string;
  representanteLegal?: string;
  nombreRepresentanteLegal?: string;
  tipoDocumentoRepresentante?: string;
  numeroDocumentoRepresentante?: string;
  ambienteSunat?: string;
  facturarEn?: string;
  esActivo?: boolean;
  esPrincipal?: boolean;
  planSku?: string;
}

export interface UpdateEmpresaDTO extends Partial<CreateEmpresaDTO> {
  id: string;
}

export const empresasService = {
  getAll: (params?: { page?: number; per_page?: number; search?: string }): Promise<ApiResponse<PaginatedResponse<Empresa>>> => {
    return httpClient.get('/empresas', params);
  },

  getById: (id: string): Promise<ApiResponse<Empresa>> => {
    return httpClient.get(`/empresas/${id}`);
  },

  create: (data: CreateEmpresaDTO): Promise<ApiResponse<Empresa>> => {
    return httpClient.post('/empresas', data);
  },

  update: (data: UpdateEmpresaDTO): Promise<ApiResponse<Empresa>> => {
    return httpClient.put(`/empresas/${data.id}`, data);
  },

  delete: (id: string): Promise<ApiResponse<void>> => {
    return httpClient.delete(`/empresas/${id}`);
  },

  toggleStatus: (id: string): Promise<ApiResponse<Empresa>> => {
    return httpClient.patch(`/empresas/${id}/toggle-status`);
  },

  setPrincipal: (id: string): Promise<ApiResponse<Empresa>> => {
    return httpClient.patch(`/empresas/${id}/set-principal`);
  },

  iniciarHabilitacionPse: (id: string, evidenciaArchivoId?: string): Promise<ApiResponse<Empresa>> => {
    return httpClient.patch(`/empresas/${id}/habilitacion-pse/iniciar`, { evidenciaArchivoId });
  },

  obtenerEvidenciaHabilitacionPse: (id: string, descargar = false): Promise<Blob> => {
    return httpClient.obtenerBlob(
      `/empresas/${id}/habilitacion-pse/evidencia`,
      descargar ? { descargar: true } : undefined,
    );
  },

  confirmarHabilitacionPse: (id: string): Promise<ApiResponse<Empresa>> => {
    return httpClient.patch(`/empresas/${id}/habilitacion-pse/confirmar`);
  },

  revertirHabilitacionPse: (id: string): Promise<ApiResponse<Empresa>> => {
    return httpClient.patch(`/empresas/${id}/habilitacion-pse/revertir`);
  },

  getByRuc: (ruc: string): Promise<ApiResponse<Empresa>> => {
    return httpClient.get('/empresas', { ruc });
  },
};
